module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "tip-content"
  }, [_c('p')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587bea88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lucky-drawer-activity/components/Rule.vue
// module id = 614
// module chunks = 1